<template>
  <div class="vttop">
    <div class="topbox container">
      <div class="numbox clearfix">
        <div class="item">
          <h3>注册志愿者（人）</h3>
          <CountUp
            :delay="delay"
            :endVal="endVal1"
            :options="options"
          />
        </div>
        <div class="item">
          <h3>志愿服务时长（小时）</h3>
          <CountUp
            :delay="delay"
            :endVal="endVal2"
            :options="options"
          />
        </div>
        <div class="item">
          <h3>志愿服务组织（个）</h3>
          <CountUp
            :delay="delay"
            :endVal="endVal3"
            :options="options"
          />
        </div>
      </div>
    </div>
    <canvas id="water" height="400"></canvas>
  </div>
</template>

<script>
import { volunteerdata } from '@/api/volunteer/index'
import CountUp from 'vue-countup-v2'
export default {
  name: 'volunteerdata',
  data () {
    return {
      delay: 1000,
      endVal1: 0,
      endVal2: 0,
      endVal3: 0,
      options: {
        useEasing: true,
        useGrouping: true,
        separator: '',
        decimal: '',
        prefix: '',
        suffix: ''
      }
    }
  },
  components: {
    CountUp
  },
  mounted () {
    // 兼容的requestAnimationFrame函数
    let requestAnimationFrame = (function () {
      return window.requestAnimationFrame || function (
        callback) {
        window.setTimeout(callback, 1000 / 60)
      }
    })()

    // 封装设置canvas大小的函数
    let setCanvasSize = function () {
      canvas.width = canvas.parentNode.offsetWidth
      canvas.height = canvas.parentNode.offsetHeight
    }

    // 获取canvas相关
    let canvas = document.querySelector('#water')
    let ctx = canvas.getContext('2d')
    setCanvasSize()

    // 一些变量
    let boHeight = canvas.height / 9 // 顶峰高度
    let posHeight = canvas.height / 1.2 // 最低高度
    let step = 0 // 初始角度
    let colors = ['rgba(246, 249, 254, 1)', 'rgba(246, 249, 254, 0.1)', 'rgba(246, 249, 254, 0.06)', 'rgba(246, 249, 254, 0.2)']

    // 绘制函数
    let paint = function () {
      ctx.clearRect(0, 0, canvas.width, canvas.height) // 清空画布
      step += 1 // 角度

      // 遍历colors数组，进行绘制
      colors.forEach((item, index) => {
        ctx.fillStyle = item // 画笔的颜色
        let angle = (step + index * 50) * Math.PI / 180 // 相差的角度
        let deltaHeight = Math.sin(angle) * boHeight // 线条左边的起点
        let deltaHeightRight = Math.cos(angle) * boHeight // 线条右边的终点
        ctx.beginPath()
        ctx.moveTo(0, posHeight + deltaHeight)
        ctx.bezierCurveTo(canvas.width / 2, posHeight + deltaHeight, canvas.width / 2, posHeight +
          deltaHeightRight, canvas.width, posHeight + deltaHeightRight) // 绘制贝塞尔曲线
        ctx.lineTo(canvas.width, canvas.height) // 防止右侧出现空隙
        ctx.lineTo(0, canvas.height) // 防止左侧出现空隙
        ctx.closePath()
        ctx.fill()
      })

      requestAnimationFrame(paint) // 自调
    }
    // 调用绘制函数
    paint()
    // 响应式
    window.onresize = setCanvasSize
    this.getData()
  },
  methods: {
    getData () {
      volunteerdata(this.$cookie.get('culturalCloud_fid')).then(res => {
        if (res.data.volunteer > 0) this.endVal1 = res.data.volunteer
        if (res.data.serviceTime > 0) this.endVal2 = res.data.serviceTime
        if (res.data.volunteerGroup > 0) this.endVal3 = res.data.volunteerGroup
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.vttop{
  padding: 60px 0 0 0;
  height: 400px;
  background: -webkit-linear-gradient(left, #64cafa , #6561f4); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right, #64cafa, #6561f4); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, #64cafa, #6561f4); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right, #64cafa , #6561f4); /* 标准的语法 */
  filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#64cafa, endColorstr=#6561f4);
  position:relative;
  .topbox{
    position:relative;
    z-index: 1;
    .numbox{
      margin: 0 -50px;
      .item {
        width: 33.3333333%;
        padding: 0 50px;
        float: left;
        text-align: center;
        h3 {
          color: #fff;
          font-size: 20px;
          line-height: 80px;
        }
        span{
          display: inline-block;
          font-size: 36px;
          color: #fff;
          padding: 0 10px;
          height: 66px;
          line-height: 66px;
          margin: 0px 3px;
          text-align: center;
          background: #ffaa45;
          border-radius: 5px;
          list-style: none;
          cursor: pointer;
        }
        &:nth-child(2){
          span{
            background: #7ca5ff;
          }
        }
        &:nth-child(3){
          span{
            background: #74d4c8;
          }
        }
      }
    }
  }
  #water {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 0;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/volunteercenter/volunteerdata.vue